import { createReducer } from '@reduxjs/toolkit';
import { FavoriteShape } from './model';
import * as favoriteActions from './actions';
import { applyTotal, EMPTY_TOTAL, Loading } from '../finder/model';

const initial: FavoriteShape = {
  data: { assets: [], total: EMPTY_TOTAL, asset_ids: [] },
  loading: Loading.none,
  hasNextPage: false,
  scrollHash: '',
  inProgress: {},
  allInProgress: false,
};

export const favoriteReducer = createReducer<FavoriteShape>(initial, (builder) =>
  builder
    .addCase(favoriteActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(favoriteActions.assetsChanged, (s, a) => {
      s.data.assets = a.payload.data.assets;
      s.data.asset_ids = a.payload.data.asset_ids ?? s.data.asset_ids;
      applyTotal(s.data.total, a.payload.data.total);

      s.hasNextPage = a.payload.hasNextPage;
      s.scrollHash = a.payload.scrollHash;
    })
    .addCase(favoriteActions.thumbnailUpdated, (s, a) => {
      s.data.assets = s.data.assets.map((asset) =>
        asset.id === a.payload.assetId ? { ...asset, thumbnail_url: a.payload.url } : asset,
      );
    })
    .addCase(favoriteActions.setAllInProgress, (s, a) => {
      s.allInProgress = a.payload.allInProgress;
    })
    .addCase(favoriteActions.setInProgress, (s, a) => {
      if (a.payload.inProgress) {
        a.payload.ids.forEach((id) => {
          s.inProgress[id] = true;
        });
      } else {
        a.payload.ids.forEach((id) => {
          delete s.inProgress[id];
        });
      }
    }),
);
